import { t } from "ttag";

import {
  NewTabWarning,
  getNewTabTitle,
} from "metabase/common/components/ExternalLink";
import { ForwardRefLink } from "metabase/common/components/Link";
import type { InsightsMenuItemProps } from "metabase/plugins";
import { Icon, Menu } from "metabase/ui";
import * as Urls from "metabase/urls";
import { useGetAuditInfoQuery } from "metabase-enterprise/api";

export const InsightsMenuItem = ({
  card,
  label,
  iconName = "external",
  withDivider = false,
}: InsightsMenuItemProps) => {
  const { data: auditInfo, error, isLoading } = useGetAuditInfoQuery();

  if (isLoading || error || !auditInfo?.question_overview) {
    return null;
  }

  if (card.collection?.type === "instance-analytics") {
    return null;
  }

  const params = new URLSearchParams({ question_id: String(card.id) });
  const url = `${Urls.dashboard({ id: auditInfo.question_overview, name: "" })}?${params}`;

  return (
    <>
      {withDivider && <Menu.Divider role="separator" />}
      <Menu.Item
        component={ForwardRefLink}
        to={url}
        target="_blank"
        title={getNewTabTitle()}
        leftSection={<Icon name={iconName} />}
      >
        {label ?? t`Insights`}
        <NewTabWarning />
      </Menu.Item>
    </>
  );
};
